<template>
  <div class="max-w-3xl mx-auto space-y-6">
    <Paragraph>{{ t("cookie.intro") }}</Paragraph>

    <!-- Functional Cookies -->
    <Section :title="t('cookie.functionalCookiesTitle')">
      <Paragraph>{{ t("cookie.functionalCookiesText") }}</Paragraph>
      <Table
        :headers="Array.from({ length: functionalHeadersCount })"
        :rows="Array.from({ length: functionalRowsCount })" />
    </Section>

    <!-- Analytical Cookies -->
    <Section :title="t('cookie.analyticsCookiesTitle')">
      <Paragraph>{{ t("cookie.analyticsCookiesText") }}</Paragraph>
      <Table
        :headers="Array.from({ length: analyticsHeadersCount })"
        :rows="Array.from({ length: analyticsRowsCount })" />
    </Section>

    <!-- Marketing Cookies -->
    <Section :title="t('cookie.marketingCookiesTitle')">
      <Paragraph>{{ t("cookie.marketingCookiesText") }}</Paragraph>
      <Table
        :headers="Array.from({ length: marketingHeadersCount })"
        :rows="Array.from({ length: marketingRowsCount })" />
    </Section>

    <!-- Deleting Cookies -->
    <Section :title="t('cookie.deletingCookiesTitle')">
      <Paragraph>{{ t("cookie.deletingCookiesText") }}</Paragraph>
      <Paragraph class="text-xs text-gray-500">
        {{ t("cookie.lastUpdated") }}
      </Paragraph>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Section from "@/components/ui/Section.vue";
import Paragraph from "@/components/ui/Paragraph.vue";
import Table from "@/components/ui/Table.vue";

interface CookieTranslations {
  cookie: {
    functionalCookiesTable: {
      headers: string[];
      rows: string[][];
    };
    analyticsCookiesTable: {
      headers: string[];
      rows: string[][];
    };
    marketingCookiesTable: {
      headers: string[];
      rows: string[][];
    };
  };
}

const { t, locale, messages } = useI18n();
const cookieMessages = messages.value[locale.value] as unknown as CookieTranslations;

const functionalHeadersCount = cookieMessages.cookie.functionalCookiesTable.headers.length || 0;
const functionalRowsCount = cookieMessages.cookie.functionalCookiesTable.rows.length || 0;

const analyticsHeadersCount = cookieMessages.cookie.analyticsCookiesTable.headers.length || 0;
const analyticsRowsCount = cookieMessages.cookie.analyticsCookiesTable.rows.length || 0;

const marketingHeadersCount = cookieMessages.cookie.marketingCookiesTable.headers.length || 0;
const marketingRowsCount = cookieMessages.cookie.marketingCookiesTable.rows.length || 0;
</script>
